import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useCart } from "@/lib/CartContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const order = params.get("order");
  const { refresh } = useCart();

  useEffect(() => {
    // Reset local cart id so user starts fresh
    localStorage.removeItem("vitura_cart_id");
    refresh();
  }, [refresh]);

  return (
    <div className="max-w-xl mx-auto px-6 md:px-10 py-20 text-center" data-testid="checkout-success">
      <div className="label !text-[10px]">Order confirmed</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-[-0.03em] leading-[1.0] mt-4">
        Welcome to <span className="editorial normal-case">Vitura</span>.
      </h1>
      <p className="mt-6 text-[15px] text-[color:var(--ink-2)]">
        We just received your order{order ? <> · <span className="font-mono text-[12px]">{order.slice(0, 8)}</span></> : null}. A confirmation email is on its way.
      </p>
      <div className="mt-10 flex items-center justify-center gap-3">
        <Link to="/preview" className="h-11 px-5 border border-[color:var(--line)] label !tracking-[0.25em] leading-[44px]">Home</Link>
        <Link to="/journal" className="h-11 px-5 bg-[#0f0f10] text-[#faf9f5] label !tracking-[0.25em] leading-[44px]">Read the journal</Link>
      </div>
    </div>
  );
}
